import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';

export const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    createCreditCardFee: build.mutation({
      query: (args) => ({
        url: `${apiUrl.creditCardFeeRate}`,
        method: 'POST',
        body: args,
      }),
      invalidatesTags: ['creditCardFeeRate'],
    }),
    getCreditCardFee: build.query({
      query: () => ({
        url: `${apiUrl.creditCardFeeRate}`,
        method: 'GET',
      }),
      providesTags: ['creditCardFeeRate'],
    }),
  }),
  overrideExisting: false,
});

export const { useCreateCreditCardFeeMutation, useGetCreditCardFeeQuery } = extendedApi;
